import { useState, useEffect } from "react";
import api from "../../../../utils/api";

const useLogin = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem("savedUsername");
    const rememberMeFlag = localStorage.getItem("rememberMe");
    if (rememberMeFlag === "true" && savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async () => {
    setIsLoading(true);
    setError("");
    try {
      const response = await api.post("/auth/login", { username, password });

      if (response.data.token) {
        const { token, username: loggedInUser, role, mustChangePassword } = response.data;

        localStorage.setItem("token", token);
        localStorage.setItem("username", loggedInUser);
        localStorage.setItem("role", role);
        localStorage.setItem("userId", response.data.userId);

        if (mustChangePassword) {
          localStorage.setItem("mustChangePassword", "true");
        } else {
          localStorage.removeItem("mustChangePassword");
        }

        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
          localStorage.setItem("savedUsername", loggedInUser);
        } else {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("savedUsername");
        }

        onLoginSuccess(token);
      }
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Invalid username or password";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setIsForgotPasswordOpen(true);
  };

  return {
    username, setUsername,
    password, setPassword,
    rememberMe, setRememberMe,
    error,
    showPassword, setShowPassword,
    isLoading,
    isForgotPasswordOpen,
    closeForgotPassword: () => setIsForgotPasswordOpen(false),
    handleLogin,
    handleForgotPassword,
  };
};

export default useLogin;
